import React from "react";
const InputTextArea = (props) => {
  return (
    <div className="textarea-box input__box">
      <label className="input__label">
        {props.title}
        {props.note && (
          <span style={{ fontSize: "2rem", color: "red", marginLeft: "1rem" }}>
            {props.note}{" "}
          </span>
        )}
      </label>

      <textarea
        name={props.name}
        className="textarea-field input__field  input__field--gray"
        placeholder={props.placeholder}
        value={props.value}
        onChange={props.onChange}
        required={props.required}
      ></textarea>
    </div>
  );
};

export default InputTextArea;
